<script setup>
import { vOnClickOutside } from '@vueuse/components'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import useLayout from '@/useLayout';

const { isRightSidebarOpen } = useLayout();
const breakpoints = useBreakpoints(breakpointsTailwind);

function handleClickOutsideRightSidebar() {
    if (breakpoints.isSmaller('md')) {
        isRightSidebarOpen.value = false;
    }
}
</script>

<template>
    <aside 
        v-on-click-outside="handleClickOutsideRightSidebar"
        class="bg-slate-100 h-dvh p-4"
    >   
        <slot></slot>
    </aside>
</template>
